import '../../styles/pages/common/commonPage.scss';
import SubPageContentHolder from '../../components/subPageContentHolder/SubPageContentHolder';
import { plusSignSVG, questionSVG } from '../../lib/allCustomSVGs';
import { useTranslation } from 'react-i18next';
import PageWrapperMain from '../../components/page-wrappers/PageWrapperMain';
import SubPageInnerContentHolder from '../../components/subPageContentHolder/SubPageInnerContentHolder';
import MCP from './MCP/MCP';
import { useEffect, useState } from 'react';
import Popup from '../../ui/popup/Popup';
import RequestMCP from './MCP/RequestMCP';
import get_all_available_mcp_api_call from '../../lib/api/mcp/get-all-available-mcp';
import FilterBox from '../../ui/boxes/FilterBox';
import HELP_LINKS from '../../lib/constants/helpLinks';

const Integrations = () => {
  const { t } = useTranslation();

  const [isRequestMCPPopupOpen, setIsRequestMCPPopupOpen] = useState(false);
  const [scheduledMCPs, setScheduledMCPs] = useState<any>([]);
  const [searchValue, setSearchValue] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('All Status');
  const [loading, setLoading] = useState('pending');

  const toggleRequestMCPPopupModal = () => {
    setIsRequestMCPPopupOpen(!isRequestMCPPopupOpen);
  };

  const getAllPendingMCP = async () => {
    setLoading('pending');
    const res = await get_all_available_mcp_api_call(true);
    if (res && res?.length > 0) {
      setLoading('success');
      setScheduledMCPs(res);
    } else {
      setLoading('null');
      setScheduledMCPs([]);
    }
  };

  useEffect(() => {
    getAllPendingMCP();
  }, []);

  return (
    <PageWrapperMain>
      <div className='subPage'>
        <SubPageContentHolder>
          <SubPageInnerContentHolder
            title={t('IntegrationsHub')}
            // subTitle={t('MCP-SubTitle')}
            backgroundColor={'var(--main-background-color)'}
            /* ------Request New Integration Button------ */
            secondaryBtnTitle={t('RequestNewIntegration')}
            secondaryBtnIcon={plusSignSVG}
            secondaryBtnLoading={false}
            secondaryBtnAction={toggleRequestMCPPopupModal}
            secondaryButtonType='white'
            /* ------Help Button------ */
            mainButtonType='white'
            mainBtnTitle={t('HelpMeConnect')}
            mainBtnIcon={questionSVG}
            mainBtnLoading={false}
            mainBtnLink={HELP_LINKS.integrations.integrationsHub}
            isMainBtnLinkExternal={true}
          >
            <div className='mcp_page'>
              <FilterBox
                filterOptions={[
                  'All Status',
                  'Connected',
                  'Not Connected',
                  // 'Failed',
                  'Disconnected',
                  'Not Configured',
                ]}
                extraClassName='mcpIntegration-filterBox--identifier'
                initialFilter='All Status'
                placeholder={t('Search integrations...')}
                onSearchChange={(value) => setSearchValue(value)}
                onFilterChange={(filter) => setSelectedFilter(filter)}
              />

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '2rem',
                  marginBottom: '2rem',
                }}
              >
                <MCP
                  searchValue={searchValue}
                  selectedFilter={selectedFilter}
                />
              </div>
            </div>

            {/* Request MCP Popup */}
            <Popup
              styles={{ backgroundColor: '#fff' }}
              setTrigger={toggleRequestMCPPopupModal}
              trigger={isRequestMCPPopupOpen}
            >
              <RequestMCP
                scheduledMCPs={scheduledMCPs}
                loading={loading}
                toggleRequestMCPPopupModal={toggleRequestMCPPopupModal}
              />
            </Popup>
          </SubPageInnerContentHolder>
        </SubPageContentHolder>
      </div>
    </PageWrapperMain>
  );
};

export default Integrations;
